import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// ── Request interceptor — attach token ───────────────
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jengo_token');
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ── Response interceptor — handle errors globally ────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message;
    const code = error.response?.data?.code;

    if (code === 'TOKEN_EXPIRED' || status === 401) {
      localStorage.removeItem('jengo_token');
      localStorage.removeItem('jengo_user');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    if (code === 'TENANT_LOCKED') {
      window.location.href = '/suspended';
      return Promise.reject(error);
    }

    if (status === 403) {
      toast.error(message || 'You do not have permission to do that.');
    }

    if (status === 500) {
      toast.error('Something went wrong on the server. Please try again.');
    }

    return Promise.reject(error);
  }
);

export default api;
